import { createContext } from 'react';
var globalElement = null;
export var defaultContextValue = {
  boundaryElement: null,

  get element() {
    if (globalElement) return globalElement;
    globalElement = document.createElement('div');
    globalElement.setAttribute('data-portal', '');
    document.body.appendChild(globalElement);
    return globalElement;
  }

};
export var PortalContext = createContext(defaultContextValue);